import { SubscriptionTier, getAvailableFields } from '../config/subscriptionTiers';

export const filterProfileByTier = (profile: any, tier: SubscriptionTier): any => {
  const availableFields = getAvailableFields(tier);
  const filteredProfile: any = {};

  // Always include these essential fields regardless of tier
  const essentialFields = ['_id', 'userId', 'createdAt', 'updatedAt'];
  
  Object.keys(profile).forEach(key => {
    if (availableFields.includes(key) || essentialFields.includes(key)) {
      filteredProfile[key] = profile[key];
    }
  });

  return filteredProfile;
};

export const cleanProfileOnDowngrade = async (
  profile: any, 
  oldTier: SubscriptionTier, 
  newTier: SubscriptionTier
): Promise<any> => {
  // Only clean if downgrading
  const tiers: SubscriptionTier[] = ['FREE', 'PRO', 'BUSINESS_PRO'];
  const oldIndex = tiers.indexOf(oldTier);
  const newIndex = tiers.indexOf(newTier);
  
  if (newIndex >= oldIndex) {
    return profile; // Not a downgrade, return as is
  }

  return filterProfileByTier(profile, newTier);
};
